var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoDataBarChart = function SvgNoDataBarChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 99 65"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D63",
    d: "M1 .5a.5.5 0 0 0-1 0V64a1 1 0 0 0 1 1h97.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#573E2F",
    d: "M18 63V12a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v51m64 0V36a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v27m-26 0V19a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v44m28 0V26a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v37m46 0V41a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v22"
  })));
};
export default SvgNoDataBarChart;